// extracted by extract-css-chunks-webpack-plugin
module.exports = {"row":"PriceList_row-3W-jf"};